import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.updateButtonState();
  }

  change(event) {
    this.sendAnswer(event);
    this.updateButtonState();
  }

  sendAnswer(event) {
    const input = event.target;
    if (!input || !input.checked) return;

    const answerId = input.dataset.answerId;
    const answer = input.value;

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    fetch(`/mypage/shindan/dna12_answers/${answerId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/plain",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({
        shindan_dna12_answer_id: answerId,
        answer: answer,
      }),
      credentials: "same-origin",
    }).then((res) => {
      if (!res.ok) throw new Error("Failed to update answer");
      return res.text();
    }).catch((err) => {
      console.error(err);
    });
  }

  updateButtonState() {
    const radioInputs = this.element.querySelectorAll('.shindan-seven-card__radio-input');
    if (radioInputs.length === 0) return;

    const allGroupNames = new Set(Array.from(radioInputs).map((r) => r.name));
    const checkedGroupNames = new Set(Array.from(radioInputs).filter((r) => r.checked).map((r) => r.name));
    const allAnswered = allGroupNames.size > 0 && checkedGroupNames.size === allGroupNames.size;

    const nextButton = this.element.querySelector('.page-shindan-forms__actions .page-shindan-forms__next-button');
    if (nextButton) nextButton.disabled = !allAnswered;
  }
}
